<div class="layout-column side-menu">

  <div class="layout-row space-between justify-end">

    <svg class="close" (click)="closeMenu()" aria-label="close menu" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0" y="0"
      viewBox="0 0 15 15" xml:space="preserve">
      <path class="st0" stroke='#1b0e3d' d="m.5.5 14 14M14.5.5l-14 14" />
    </svg>
  </div>

  <div class="layout-row spacer-top-16">
    <div class="layout-column full-w">
      @for (item of menu; track item) {
        @if (item.label === 'Blog') {
          <div class="tab bold">
            <a [href]="root" (click)="navClick('Blog','side menu')">{{item.label}}</a>
          </div>
        } @else {
          @if (item.label === 'Support') {
            <div class="tab">
              <a [href]="support" (click)="navClick(item.label,'side menu')">{{item.label}}</a>
            </div>
          } @else {
            @if (item.submenu) {
              <div class="tab has-dropdown">
                <span>{{item.label}}</span>
                <input type="checkbox">
                <svg class="down-arrow" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.486 6.53625L6.94971 11.8995L2.41345 6.53625" stroke="#1B0E3D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <div class="dropdown-menu layout-column">
                  @for (subItem of item.submenu; track subItem) {
                    <a [href]="subItem.label === 'Support' ? support : website+subItem.page" [class.bold]="subItem.label === 'Blog'"
                    (click)="navClick('Blog','side menu')">{{subItem.label}}</a>
                  }
                </div>
              </div>
            } @else {
              <div class="tab">
                <a [href]="website+item.page" (click)="navClick(item.label,'side menu')">{{item.label}}</a>
              </div>
            }
          }
        }
      }
      <div class="separator"></div>
      <div class="tab">
        <a [href]="webapp" (click)="navClick('Log in','side menu')">Log in</a>
      </div>
    </div>
  </div>
</div>
